import React from 'react';
import PropTypes from 'prop-types';

import { ButtonList } from 'wsm-vehicle-cta-display';
import { useRequestData } from 'wsm-common-data';

const CTAButtonList = ({ targetLocations, buttons }) => {
	const { windowId } = useRequestData();

	const processedButtons = buttons?.map((button) => {
		if (
			button.btnAttributes &&
			typeof button.btnAttributes.onClick === 'string'
		) {
			/* eslint-disable-next-line no-new-func, no-param-reassign */
			button.btnAttributes.onClick = new Function(
				'element',
				button.btnAttributes.onClick
			);
		}
		return button;
	});

	return (
		<>
			{/* ePrice portal container for ws-detailed-pricing to insert ePrice button. */}
			{windowId === 'vehicle-ctas1' && (
				<div
					className="eprice-react-portal"
					data-testid="eprice-portal"
					data-target-locations={[...targetLocations].join(' ')}
				/>
			)}
			<ButtonList
				buttons={processedButtons}
				dataLocation={targetLocations}
			/>
		</>
	);
};

export default CTAButtonList;

CTAButtonList.propTypes = {
	targetLocations: PropTypes.instanceOf(Set).isRequired,
	buttons: PropTypes.arrayOf(PropTypes.object).isRequired
};
